import { render, staticRenderFns } from "./IsAProspect.vue?vue&type=template&id=a2435e40&scoped=true&"
import script from "./IsAProspect.vue?vue&type=script&lang=js&"
export * from "./IsAProspect.vue?vue&type=script&lang=js&"
import style0 from "./IsAProspect.vue?vue&type=style&index=0&id=a2435e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2435e40",
  null
  
)

export default component.exports